<div
  #pickrContainer
  class="another pickr-container {{
    useParentElementAsButton ? 'w-full h-full ' : ''
  }}"></div>
